<template>
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.45 13.5875C11.325 13.575 11.175 13.575 11.0375 13.5875C8.06245 13.4875 5.69995 11.05 5.69995 8.05C5.69995 4.9875 8.17495 2.5 11.25 2.5C14.3125 2.5 16.8 4.9875 16.8 8.05C16.7875 11.05 14.425 13.4875 11.45 13.5875Z" stroke="#2C2738" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M20.5126 5C22.9376 5 24.8876 6.9625 24.8876 9.375C24.8876 11.7375 23.0126 13.6625 20.6751 13.75C20.5751 13.7375 20.4626 13.7375 20.3501 13.75" stroke="#2C2738" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M5.1999 18.2C2.1749 20.225 2.1749 23.525 5.1999 25.5375C8.6374 27.8375 14.2749 27.8375 17.7124 25.5375C20.7374 23.5125 20.7374 20.2125 17.7124 18.2C14.2874 15.9125 8.6499 15.9125 5.1999 18.2Z" stroke="#2C2738" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M22.925 25C23.825 24.8125 24.675 24.45 25.375 23.9125C27.325 22.45 27.325 20.0375 25.375 18.575C24.6875 18.05 23.85 17.7 22.9625 17.5" stroke="#2C2738" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
import iconMixin from "@/services/iconMixins.js";

export default {
  mixins: [iconMixin]
};
</script>
